<template lang="pug">
.wrap
  .filter-wrap
    .first-level
      .first-level-item.filter-item-label(v-for="root in filterData" :class='{"first-level-item-active": root.params === selected.firstLevel}', :key="'firstlevel' + root.id" @click='onSelectedFirstLevel(root)') {{root.name}}
    div(v-for="root in filterData" :key="'firstlevel1' + root.id")
      .fiter-row(v-show="root.params === currentTab.params" v-for='(item, index) in root.screeningItems', :key='index + "a"')
        .filter-item-label(v-for='_item in item.items', :key='_item.params', :class='{"filter-item-label-activated": _item.params === selected[selected.firstLevel][_item.screeningType]}', @click='onSelected(_item)') {{_item.name}}
  .list
    a.video-item(v-for='(item, index) in searchResults', :key='index', target="_blank" :href="localePath('/detail/' + $semantic.type[item.domainType] + '/' + `${item.websiteParam||item.id}`+`?channel=${channel||''}&channelName=${channelName||''}&sequence=${index+1}&source=${channelName}`)"  @click="handleBury(item,index)")
      VideoCard(:title='item.name', :img='item.coverVerticalUrl')
  client-only
    infinite-loading(:identifier="infiniteIdentifier" @infinite="infiniteHandler")
  fq-ignore(v-if="isEmpty")
</template>

<script>
import getStructuredJson from '@/util/structuredData'
export default {
  name: 'home',
  components: {},
  async asyncData({ redirect, query, $ua, req, app, route }) {
    try {
      const channel = route.params.id
      const channelName = route.params.type
      const filterData = await app.$api.getFilterParams()
      const videoList = await app.$api.getSearchAndFilterResult({
        size: 18,
        params: filterData.filter((item) => String(item.id) === route.params.id)[0]?.params || route.params.params || '',
        ...query
      })
      const seoRes = await app.$api.queryKeyword()
      return {
        filterData: filterData || [],
        searchResults: videoList.searchResults || [],
        seoKeyword: seoRes.keyword,
        channel,
        channelName
      }
    } catch (e) {}
  },
  data() {
    return {
      infiniteIdentifier: '0',
      filterData: [],
      searchResults: [],
      isInfiniteLoading: false,
      size: 18,
      selected: {
        // 第一级tab，电影，电视剧，动漫;;此字段变化会重置infinite-loading
        firstLevel: ''
        // 下一级的筛选项传数据时候和这一级一起传；后面的key在mounted中遍历赋值
      }
    }
  },
  head() {
    return {
      title: this.$t('seo.allPage.title') + '- loklok all drama',
      meta: [
        { name: 'keywords', content: `${this.seoKeyword ? this.seoKeyword + ',' : ''}${this.$t('seo.allPage.keywords')}` },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.allPage.description') + '- loklok'
        },
        { rel: 'canonical', href: 'https://loklok.top' + this.localePath(this.$route.fullPath) }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: [
            getStructuredJson.bread([
              { name: this.$t('seo.index.title'), path: 'https://loklok.top' + this.localePath('/') },
              { name: this.$t('seo.allPage.title') + '- loklok all drama', path: 'https://loklok.top' + this.localePath(this.$route.fullPath) }
            ])
          ]
        }
      ]
    }
  },
  computed: {
    currentTab() {
      return this.filterData.filter((item) => item.params === this.selected.firstLevel)[0] || this.filterData[0] || {}
    },
    filterParams() {
      return {
        size: this.size,
        sort: this.searchResults.length > 0 ? this.searchResults[this.searchResults.length - 1].sort : '',
        params: this.selected.firstLevel,
        ...this.selected[this.selected.firstLevel]
      }
    },
    isEmpty() {
      return this.searchResults.length === 0 && !this.isInfiniteLoading
    }
  },
  methods: {
    handleBury(item, index) {
      this.$LokBury.handleMD(
        {
          buryEventId: 'UM_Event_ContentClick',
          buryParams: {
            UM_Key_ContentName: item.name,
            UM_Key_ContentID: item.id,
            UM_Key_ContentType: this.$semantic.cnName[item.domainType],
            UM_Key_SourceSection: null,
            UM_Key_SourceLocation: index + 1
          }
        },
        'click'
      )
    },
    resetInfinieLoading() {
      this.infiniteIdentifier = new Date().valueOf()
    },
    onSelectedFirstLevel(item) {
      // this.selected.firstLevel = item.params
      // this.searchResults = []
      // this.resetInfinieLoading()
      this.$router.push({
        path: this.localePath(`/channel/${item.id}/${item.websiteParam}`)
      })
      // this.isInfiniteLoading = false
    },
    async onSelected(item) {
      this.selected[this.selected.firstLevel][item.screeningType] = item.params
      this.searchResults = []
      this.resetInfinieLoading()
      // const list = await this.load({
      //   size: this.size,
      //   sort: '',
      //   ...this.selected
      // })
      // 跳转
      // this.searchResults.push(...list)
      // const params = Object.fromEntries(Object.entries(this.selected).filter((item) => item[1]))
      // this.$router.replace({ query: params })
      // this.$router.replace({ query: { ...this.selected } })
    },
    async infiniteHandler($state) {
      console.log('infiniteHandler', $state)
      if (this.isInfiniteLoading) return
      this.isInfiniteLoading = true
      const list = await this.load(this.filterParams)
      this.searchResults.push(...list)
      if (list?.length < this.size) {
        $state && $state.complete()
      } else {
        $state && $state.loaded()
      }
      this.isInfiniteLoading = false
    },
    async load(params) {
      try {
        const res = await this.$api.getSearchAndFilterResult(params)
        return res.searchResults || []
      } catch (e) {
        return []
      }
    }
  },
  watch: {},
  created() {
    this.filterData.forEach((root) => {
      // 应该拿params做key，但是后端的params中有逗号，，，
      this.selected[root.params] = {}
      root.screeningItems.forEach((secondItem) => {
        // if (this.$route.params.params && this.$route.params.params === root.params) {
        //   // 如果url参数里有这个筛选项，就设置为选中状态
        //   // 还需要遍历一层
        // } else {
        //   // 如果url参数里没有这个筛选项，就设置为第一个筛选项
        //   let currentFirstItem = secondItem.items[0]
        //   this.selected[root.params][currentFirstItem.screeningType] = currentFirstItem.params
        // }
        // 现在默认选中第一个筛选项，不取url参数
        let currentFirstItem = secondItem.items[0] || {}
        this.selected[root.params][currentFirstItem.screeningType] = currentFirstItem.params
        // secondItem.items.forEach((thirdItem) => {
        //   // if (this.$route.query.params && this.$route.query.params === root.params) {
        //   //   this.selected[root.params][thirdItem.screeningType] = this.$route.query[thirdItem.screeningType] || thirdItem.params
        //   // } else {
        //   //   this.selected[root.params][thirdItem.screeningType] = thirdItem.params
        //   // }
        //   this.selected[root.params][thirdItem.screeningType] = thirdItem.params
        // })
        // params是一级筛选字段   先判断一级筛选项是否有值，没有值就默认第一个，有值就拿值并且给当前一级筛选内的选项遍历赋值
        // if (this.$route.query.params && this.$route.query.params === root.params) {
        //   this.selected[root.params][currentFirstItem.screeningType] = this.$route.query[currentFirstItem.screeningType] || currentFirstItem.params
        // } else {
        //   this.selected[root.params][currentFirstItem.screeningType] = currentFirstItem.params
        // }
      })
    })
    if (this.$route.meta.menuParams) {
      // 新版地址
      this.selected.firstLevel = this.filterData.filter((item) => String(item.id) === this.$route.meta.menuParams.id)[0]?.params || ''
    } else {
      this.selected.firstLevel = this.$route.params.params || this.filterData[0]?.params || ''
    }
  }
}
</script>

<style lang="sass" scoped>

.wrap
  max-width: 1400px
  min-width: 768px
  margin: 0 auto
.swiper-wrap
  margin-top: 30px
  margin-bottom: 60px
  overflow: hidden
  position: relative
.swiper-button-next
  color: #FEFEFE
  right: 20px
.swiper-button-prev
  color: #FEFEFE
  left: 20px
  // height: 392px
// .swiper-wrapper
//   height: 392px
// .swiper-wrapper
//   width: 100% !important
//   height: 100% !important
.swiper-slide
  // width: 280px
.swiper-item
  // width: 280px
  // height: 392px
.filter-wrap
  margin-bottom: 36px
  .first-level
    display: flex
    flex-wrap: wrap
    .first-level-item
      padding-bottom: 14px
      color: $mainTextColor
    .first-level-item-active
      position: relative
    .first-level-item-active::after
      content: ' '
      width: 32px
      height: 4px
      border-radius: 4px
      background: $mainColor
      position: absolute
      bottom: 0
      left: 50%
      transform: translateX(-50%)
  .subtitle
    font-weight: bold
    font-size: 20px
    color: #DEE4E9
    line-height: 24px
    margin-bottom: 24px
  .fiter-row
    display: flex
    // overflow: scroll
    flex-wrap: wrap
  .fiter-row::-webkit-scrollbar
    width: 0 !important
  .filter-item-label
    font-weight: bold
    font-size: 16px
    line-height: 120%
    color: #999999
    margin-top: 30px
    margin-right: 30px
    flex-shrink: 0
  .filter-item-label:hover
    color: $mainColor
    cursor: pointer
  .filter-item-label-activated
    color: $mainTextColor
.list
  @include base-flex
  flex-wrap: wrap
  a
    text-decoration: none
  .video-item
    width: 15.32%
    flex-shrink: 0
    margin-right: 1.61%
    margin-bottom: 36px
    img
      width: 100%
      height: 100%
      border-radius: 8px
      object-fit: cover
    .title
      font-size: 16px
      color: #81868E
      letter-spacing: 0
      line-height: 24px
  .video-item:nth-child(6n+6)
    margin-right: 0
.seo-wrap
  height: 100px
  overflow: hidden
  position: absolute
  left: 0
  top: 0
  z-index: -1
  opacity: 0
@media screen and (max-width: 1440px)
  .list
    padding: 0 20px
  .filter-wrap
    padding: 0 20px
  .swiper-wrap
    padding: 0 20px
  .swiper-button-next
    right: 40px
  .swiper-button-prev
    left: 40px
</style>
